import classNames from "classnames";
import React from "react";
import style from "../../scss/export.module.scss";
import { ImageIcon } from "../Icons";
import "./image-placeholder.scss";

export type TImagePlaceholder = {
    aspectRatio?: string;
    fillParent?: boolean;
    bgColor?: string;
    iconColor?: string;
    iconSize?: number;
    customIcon?: JSX.Element;
};

export const ImagePlaceholder = ({
    aspectRatio = "auto",
    fillParent = false,
    bgColor = style.greyColor,
    iconColor = style.whiteColor,
    iconSize,
    customIcon,
}: TImagePlaceholder) => {
    const actualAspectRatio = fillParent ? "auto" : aspectRatio;
    const Icon = () => customIcon ?? <ImageIcon color={iconColor} {...(!iconSize ? {} : { size: iconSize })} />;

    return (
        <div
            className={classNames("c-image-placeholder", {
                "c-image-placeholder--fill": fillParent,
                "c-image-placeholder--dynamic-icon-size": !iconSize,
            })}
            role="img"
            aria-label="Placeholder"
            style={{ aspectRatio: actualAspectRatio, background: bgColor }}
        >
            <Icon />
        </div>
    );
};

export default ImagePlaceholder;
